import React from "react";

export const RecipeTagSelector = ({
  options = { recipeOptions: [] },
  clickOption,
}) => {
  const ContainerStyle = {
    margin: "32px 0px",
    display: "flex",
    flexWrap: "wrap",
  };

  const OptionStyle = {
    margin: "12px",
    marginLeft: "24px",
  };

  const opts = options.recipeOptions.map((opt) => {
    return (
      <div key={opt} style={OptionStyle}>
        <input
          name={`keywords_${opt}`}
          id={`keywords_${opt}`}
          type="checkbox"
          checked={options[opt]}
          onChange={(e) => clickOption(e)}
        />
        <label htmlFor={`keywords_${opt}`}>{opt}</label>
      </div>
    );
  });

  return (
    <div className="recipeTagSelector" style={ContainerStyle}>
      {opts}
    </div>
  );
};
